<template>
	<div class="joint_manage_invite bg-white">
		<h3 class="module-title">{{ getNickName }}邀请您共同管理患者档案</h3>
		<div class="list">
			<base-list-item
				type="primary"
				hide-checked
				hide-tag
				hide-border
				:user-name="patientInfo.patientName"
				:gender="$status.gender[patientInfo.gender]"
				:age="patientInfo.age"
			/>
		</div>
		<patient-relation v-model="relation" />
		<div class="action">
			<van-button
				type="primary"
				block
				:loading="loading"
				loading-text="加载中..."
				:disabled="!allowSubmit"
				@click="clickApplyBind"
			>
				申请绑定
			</van-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'joint-manage-invite',
		data: () => ({
			loading: false,
			patientInfo: {},
			relation: ''
		}),
		created () {
			this.getPatientStatusByApplyId()
		},
		computed: {
			getNickName () {
				if (this.patientInfo.nickname) return this.patientInfo.nickname
				if (this.patientInfo.auditAccountPhone) return this.patientInfo.auditAccountPhone
				return '--'
			},
			allowSubmit () {
				if (this.relation === '') return false
				return true
			}
		},
		methods: {
			// 检测当前账号是否绑定其他医生
			getPatientStatusByApplyId () {
				this.loading = true
				this.$api.patient.getPatientStatusByApplyId(this.$route.params.id).then(res => {
					this.loading = false
					if (!res.code) {
						if (res.data) {
							this.$dialog.alert({
								title: '温馨提示',
								message: '该患者已绑定其他医生'
							}).then(() => {
								this.$router.replace('/jointManage/list')
							})
						} else {
							this.getInviteInfo()
						}
					}
				}).catch(() => this.loading = false)
			},

			// 获取邀请人信息
			getInviteInfo () {
				this.loading = true
				this.$api.patient.geApplyStatusByApplyId(this.$route.params.id).then(res => {
					this.loading = false
					if (!res.code) {
						// 待申请时，证明已邀请，自动跳到审核结果页
						if (res.data.approveStatus == 3) {
							this.patientInfo = res.data
						} else {
							this.goApplyPage()
						}
					}
				}).catch(() => this.loading = false)
			},
			// 点击绑定
			clickApplyBind () {
				this.loading = true
				this.$api.patient.applyCommonPipe({
					id: this.$route.params.id,
					relation: this.relation
				}).then(res => {
					this.loading = false
					if (!res.code) {
						this.goApplyPage()
					}
				}).catch(() => this.loading = false)
			},
			// 前往审核页
			goApplyPage () {
				this.$router.replace({
					path: `/jointManage/result/${ this.$route.params.id }`,
					query: { type: 'apply' }
				})
			}
		}
	};
</script>

<style scoped lang="less">
	.joint_manage_invite{
		box-sizing: border-box;
		min-height: 100vh;
		padding: 155px 40px 0;
		text-align: center;
		.list {
			margin: 40px 0 160px;
			padding: 0 120px;
		}
		.action {
			width: 416px;
			margin: 237px auto 50px;
		}
	}
</style>
